import $ from 'jquery'
import { mapState } from 'vuex'


export default {
    name: 'secondary-nav',
    data: () => ({
        items: null,
        activeItem: null
      }),
    mounted() {
      if (!this.isXPE ) {
            this.items = this.$el.querySelectorAll('.secondary-nav-item')
            this.activeItem = this.$el.querySelector('.secondary-nav-item.active') || this.$el.querySelectorAll('.secondary-nav-items .secondary-nav-item ')[0]
            
            this.clickHandler(this.activeItem, false)
            this.items.forEach((item) => item.addEventListener('click', (e) => {
                this.clickHandler(item, e.target)
            }))

            this.items.forEach((item) => item.addEventListener('keyup', (e) => {
                if (e.keyCode == 32) {
                    this.clickHandler(item,e.target)
                }
            }))  
        }
    },
    computed: {
        ...mapState('global', ['isXPE','lang']),
        ...mapState('responsive', ['breakpoints', 'width']),
        isMobile() {
            return this.width <= 767
        },
        scope() {
            return {
              clickHandler: this.clickHandler,
            }
        }
    },
     
    methods: { 
        clickHandler(item,target)  {
            this.activeItem = item
            if (target !== false) {
                const url = this.activeItem.querySelector('a').getAttribute('href')
                this.items.forEach(elem => {
                    elem.classList.remove('active')
                }) 
                this.$nextTick(() => {
                    setTimeout(() => { 
                        this.activeItem.classList.add('active')
                    }, 500)
                })
            }  else {
                this.activeItem.classList.add('active')
            }
             
            if (!this.isMobile) {
                setTimeout(() => { 
                    let mohgSlider = this.$el.querySelector('.mohg-slider')
                    let rect = this.activeItem.getBoundingClientRect()
                    let width = rect.width
                    let left = $(this.activeItem).position().left
                    let finalLeftPosition = this.lang !== 'ar-ae' ? (left + 40) + "px"  : (left + 20) + "px"  
                    mohgSlider.style.width = width + "px"
                    mohgSlider.style.left = finalLeftPosition
                }, 100)
            }
        }
    },
    render() {
        return this.$scopedSlots.default(this.scope)
    }     
  }

 



 


 